import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column'
  },

  header: {
    display: 'flex',
    alignItems: 'center',
    fontSize: theme.size.sm,
    textTransform: 'uppercase',

    '& > .icon': {
      display: 'flex',
      alignItems: 'center',
      marginRight: '9px'
    },

    '& .buttons': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',

      '& > :not(:last-child)': {
        marginRight: '1rem',

        [theme.breakpoints.down('lg')]: {
          marginRight: '0.5rem'
        }
      }
    },

    [theme.breakpoints.down('lg')]: {
      fontSize: theme.size.sm
    }
  },

  inputHolder: {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    margin: '20px 0 0 0',
    width: '100%'
  },

  input: {
    display: 'flex',
    alignItems: 'center',
    flexGrow: 1,
    padding: '0.6rem 0 0 0',
    outline: 'none',
    border: 'none',
    fontSize: theme.size.sm,
    opacity: '0.7',
    width: 'calc(100% - 20px)'
  },

  delete: {
    cursor: 'pointer',
    color: '#323436'
  },

  add: {
    display: 'flex',
    alignItems: 'center',
    width: 'max-content',
    cursor: 'pointer',
    color: theme.palette.primary.main,
    userSelect: 'none',
    transition: 'color 350ms',
    fontSize: theme.size.sm,

    '& .button': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: '8px',
      borderRadius: '50%',
      boxSizing: 'border-box',
      width: '14px',
      height: '14px',
      backgroundColor: 'rgba(230, 234, 236, 0.9)'
    },

    '& .icon': {
      fontSize: theme.size.sm,
      color: '#323436'
    },

    [theme.breakpoints.down('md')]: {
      fontSize: theme.size.sm
    }
  },

  addDisabled: {
    color: '#7F8487',
    cursor: 'not-allowed'
  },

  textField: {
    position: 'relative',
    marginTop: '1rem',

    '& .icon': {
      position: 'absolute',
      top: '50%',
      right: '11px',
      transform: 'translateY(-50%)',
      fontSize: theme.size.sm,
      color: theme.palette.primary.main,
      opacity: '0.3',
      cursor: 'not-allowed'
    }
  },

  item: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '1rem',

    '& > textarea': {
      paddingTop: '0 !important',
      fontSize: theme.size.sm
    }
  },

  inputContainer: {
    display: 'flex',
    alignItems: 'center',

    '& > button[disabled]': {
      color: 'rgb(22,159,218, 0.5)',
      cursor: 'default'
    }
  },

  noteInput: {
    flex: '1',
    border: '2px solid #EFEFEF',
    borderRadius: '5px',
    boxSizing: 'border-box',
    padding: '0.125rem',
    backgroundColor: 'rgb(246, 248, 249)',
    fontSize: theme.size.sm,
    wordBreak: 'normal',
    overflowWrap: 'anywhere',

    '&:focus-within': {
      borderColor: theme.palette.primary.main,
      boxShadow: '0 0 0 0.2rem rgba(0, 123, 255, 0.25)',

      '& .MuiInputBase-input': {
        outline: '0'
      }
    },

    '& .text': {
      minHeight: '1rem',
      maxHeight: '5rem'
    },

    '& .text > div': {
      height: 'auto !important',
      maxHeight: '5rem',
      minHeight: '1rem'
    },

    '& .text > div > div': {
      height: 'auto !important',
      maxHeight: '5rem'
    }
  },

  buttonHolder: {
    alignSelf: 'baseline',
    display: 'flex',
    alignItems: 'center'
  },

  button: {
    borderRadius: '100rem',
    alignSelf: 'baseline',
    margin: '4px 8px 0 1.125rem',
    height: '1.75rem',
    padding: '0.5rem 1rem',
    fontSize: theme.size.sm,
    width: 'auto'
  },

  sendIcon: {
    marginLeft: '0.25rem'
  }
}))

export default useStyles
